// extracted by mini-css-extract-plugin
export default {"title":"SectionAccordion_title__ZaTWt","right":"SectionAccordion_right__7I0dS"};